module.exports = __webpack_public_path__ + "img/版本号 (1).074baa67.png";